import { render, staticRenderFns } from "./cliptTableList.vue?vue&type=template&id=a62fd85c&scoped=true"
import script from "./cliptTableList.vue?vue&type=script&lang=js"
export * from "./cliptTableList.vue?vue&type=script&lang=js"
import style0 from "./cliptTableList.vue?vue&type=style&index=0&id=a62fd85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62fd85c",
  null
  
)

export default component.exports